import React from 'react'

import Formimage from "./images/Formimage.svg";

const Getintouch = () => {
  return (
    <div>
      <div className="bg-[#1E2A3A] py-14 px-[8%]">
        <h2 className="text-[39px] text-[#FDBC12] font-bold text-center">
          Get in Touch with Us
        </h2>
        <p className="text-[16px] text-[#CBD5E0] text-center mt-5">
          Have questions or want to know more about our upcoming events? Get in
          touch with us today and explore opportunities <br /> to grow your
          business and contribute to your community.
        </p>

        <div className="w-[100%] flex flex-wrap bg-[#344056] border-2 border-[#94A2B8] rounded-3xl  mt-[50px]">
          <div className=" xl:w-[50%] w-[100%] p-0 hidden xl:block">
            <img className=" w-[100%]   " src={Formimage} alt="" />
          </div>
          <div className="xl:w-[50%]  w-[100%] p-[42px]">
            <form action="" method="post">-
              <section className="flex flex-col gap-2">
                <label htmlFor="Name" className="uppercase text-[#D7D3D2]">
                  Name
                </label>
                <div className="w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center">
                  <input
                    type="text"
                    name="name"
                    id=""
                    placeholder="Enter Name"
                    className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8]"
                  />
                </div>
                <label
                  htmlFor="EMAIL"
                  className="uppercase text-[#D7D3D2] mt-5"
                >
                  EMAIL
                </label>
                <div className="w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center ">
                  <input
                    type="email"
                    name="EMAIL"
                    id=""
                    placeholder="Enter Email Address"
                    className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8]"
                  />
                </div>
                <label
                  htmlFor="number"
                  className="uppercase text-[#D7D3D2] mt-5"
                >
                  MOBILE NUMBER
                </label>
                <div className="w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center ">
                  <input
                    type="text"
                    name="MOBILE"
                    placeholder="Enter MOBILE NUMBER"
                    className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8]"
                    id=""
                  />
                </div>
                <label
                  htmlFor="number"
                  className="uppercase text-[#D7D3D2] mt-5"
                >
                 MESSAGE
                </label>
                <div className="w-[100%]   ">
                  <textarea 
                    name="MOBILE"
                    placeholder="Type Here"
                    className="w-full h-[142px]  border px-2 border-[#94A2B8] rounded-lg  bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8] mt-5 pt-3"
                    id=""
                  />
                </div>
                  <button className="bg-[#FDBC12] h-[50px] text-[16px] text-[#101729] rounded-lg mt-8">Submit</button>
              </section>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Getintouch